import http from '../../../../api/http'

const BASE_URL = '/admin/jobFair';
const API_URL = `${BASE_URL}/jobNotice`;

// 기업상세 > 상시채용관 현황 > 채용공고 목록 조회
function retrieveJobNoticeListPagingByCorpId(paramObj) {
  return http.post(`${API_URL}/retrieveJobNoticeListPagingByCorpId`, paramObj);
}

export default {
  retrieveJobNoticeListPagingByCorpId,
}

